import { reactive, computed, watch } from 'vue';

export default function MyProfile(data = {}) {
    // Reactive state for dispatch user fields
    const state = reactive({
        id: data.id || '',
        lastName: data.lastName || '',
        firstName: data.firstName || '',
        email: data.email || '',
    });

    // Computed properties for validations
    const validations = {
        isLastNameValid: computed(() => !!state.lastName.trim()),
        isFirstNameValid: computed(() => !!state.firstName.trim()),
        isEmailValid: computed(() => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(state.email))
    };

    // Individual field validation functions
    const validateLastName = () => {
        if (validations.isLastNameValid.value) {
            $('#profile-last-name-input').removeClass('is-invalid');
            $('#profile-last-name-error').addClass('d-none');
            return true;
        } else {
            $('#profile-last-name-input').addClass('is-invalid');
            $('#profile-last-name-error').removeClass('d-none');
            return false;
        }
    };

    const validateFirstName = () => {
        if (validations.isFirstNameValid.value) {
            $('#profile-first-name-input').removeClass('is-invalid');
            $('#profile-first-name-error').addClass('d-none');
            return true;
        } else {
            $('#profile-first-name-input').addClass('is-invalid');
            $('#profile-first-name-error').removeClass('d-none');
            return false;
        }
    };

    const validateEmail = () => {
        if (validations.isEmailValid.value) {
            $('#profile-email-input').removeClass('is-invalid');
            $('#profile-email-error').addClass('d-none');
            return true;
        } else {
            $('#profile-email-input').addClass('is-invalid');
            $('#profile-email-error').removeClass('d-none');
            return false;
        }
    };

    // Set up watchers for real-time validation
    watch(() => state.lastName, validateLastName);
    watch(() => state.firstName, validateFirstName);
    watch(() => state.email, validateEmail);

    // Validation logic for the entire form
    const isValid = () => {
        let isLastNameValid = validateLastName();
        let isFirstNameValid = validateFirstName();
        let isEmailValid = validateEmail();

        return isLastNameValid && isFirstNameValid && isEmailValid;
    };

    // Initialize validation
    const initializeValidation = () => {
        // Only validate fields that have values
        if (state.lastName) validateLastName();
        if (state.firstName) validateFirstName();
        if (state.email) validateEmail();
    };

    // Call initialization after a short delay to ensure DOM is ready
    setTimeout(initializeValidation, 100);

    return {
        state,
        validations,
        isValid,
        initializeValidation
    };
}
